export const dataImportReducer = (
	state = {
		importData: null,
	},
	action
) => {
	switch (action.type) {
		case "IMPORTED_DATA":
			return {
				...state,
				importData: action?.payload,
			};

		default:
			return state;
	}
};
